import { styled } from 'solid-styled-components';
import theme from '../../style/theme';

export const StyledSmallCornerDialogWrapper = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 1000;
`;

export const StyledSmallCornerDialog = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: ${theme.palette.white};
    padding: 2rem;
    border-radius: 1rem;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    margin: 1rem;
    width: min-content;
`;
